import React, { PureComponent } from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

const RX_PRESCRIPTION_TERMS = gql`
  query RxPrescriptionTerms($searchString: String, $limit: Int) {
    rxPrescriptionTerms(searchString: $searchString, limit: $limit) {
      totalCount
      nodes {
        _id
        fullName
        rxcui
        strength
        fullGenericName
      }
    }
  }
`;

export default Comp => {
  @withApollo
  class WithRxPrescriptionTerms extends PureComponent {
    static propTypes = {
      client: PropTypes.object.isRequired,
      forwardedRef: PropTypes.object,
    };

    static defaultProps = {
      forwardedRef: null,
    };

    handleGetRxPrescriptionTerms = async variables => {
      const { client: apolloClient } = this.props;

      let rxPrescriptionTerms = [];

      const { data } = await apolloClient.query({
        query: RX_PRESCRIPTION_TERMS,
        variables,
      });

      if (data && data.rxPrescriptionTerms) {
        ({ rxPrescriptionTerms } = data);
      }
      return rxPrescriptionTerms;
    };

    render() {
      const { forwardedRef, ...props } = this.props;
      return (
        <Comp
          {...props}
          ref={forwardedRef}
          onGetRxPrescriptionTerms={this.handleGetRxPrescriptionTerms}
        />
      );
    }
  }

  return React.forwardRef((props, ref) => (
    <WithRxPrescriptionTerms {...props} forwardedRef={ref} />
  ));
};
